import React from 'react'
import { Button, Grid, InputAdornment, MenuItem, TextField } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import MaskedTextInput from 'asterX-UI/Inputs/MackedTextInput'
import { AutoCompleteField, SelectPlaceholder } from 'asterX-UI/Inputs'
import CombinedTextField from 'asterX-UI/Inputs/CombinedTextField'
import { DatePicker } from '@material-ui/pickers'
import DateIcon from 'asterX-UI/Icons/DateIcon'
import { GRAY_COLORS } from 'asterX-UI'
import { getStatusLabel } from '../../../lib/constants/deals'

export const FilterDesktop = ({
  page,
  homeStore,
  homeStoreFunc,
  authStoreFunc,
  combinedEventResultList,
  branchesWithCode,
  onClear,
  onSearch
}) => {
  return (
    <>
      <Grid item container spacing={4}>
        <Grid item xs={12} md={4} lg={2}>
          <TextField
            name="contractNumber"
            value={homeStore.filter?.contractNumber || ''}
            onChange={homeStoreFunc.handleFilterChange}
            fullWidth
            placeholder="Номер контракта"
          />
        </Grid>

        <Grid item xs={12} md={4} lg={2}>
          <MaskedTextInput
            name="clientIin"
            value={homeStore.filter?.clientIin || ''}
            onChange={homeStoreFunc.handleFilterChange}
            fullWidth
            mask={'999999999999'}
            placeholder="ИИН"
          />
        </Grid>

        <Grid item xs={12} md={4} lg={2}>
          <CombinedTextField
            overdueDaysFrom={homeStore.filter.overdueDaysFrom || ''}
            overdueDaysTo={homeStore.filter.overdueDaysTo || ''}
            onChange={homeStoreFunc.handleFilterChange}
            placeholder1="От дней"
            placeholder2="До дней"
          />
        </Grid>

        {page !== 'application' && (
          <>
            <Grid item xs={12} md={4} lg={2}>
              <SelectPlaceholder
                IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
                value={homeStore.filter?.overdueType || null}
                name={'overdueType'}
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                placeholder={'Тип просрочки'}
              >
                <MenuItem value={''}>Не выбрано</MenuItem>
                <MenuItem value={'SOFT'}>SOFT</MenuItem>
                <MenuItem value={'HARD'}>HARD</MenuItem>
                <MenuItem value={'LEGAL'}>LEGAL</MenuItem>
                <MenuItem value={'OFFBALANCE'}>OFFBALANCE</MenuItem>
              </SelectPlaceholder>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <MaskedTextInput
                name="clientPhone"
                value={homeStore.filter?.clientPhone || ''}
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                mask={'+7 (999)-999-99-99'}
                placeholder="Номер клиента"
              />
            </Grid>
          </>
        )}

        {!['home', 'homeLawyer', 'completed', 'renewableContracts', 'application'].includes(page) && (
          <Grid item xs={12} md={4} lg={2}>
            <SelectPlaceholder
              IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
              value={homeStore.filter?.eventResultCode || null}
              name={'eventResultCode'}
              onChange={homeStoreFunc.handleFilterChange}
              fullWidth
              placeholder={'Статус'}
            >
              <MenuItem value={''}>Не выбрано</MenuItem>
              {(combinedEventResultList || []).map(status => (
                <MenuItem key={status.code} value={status.code}>
                  {status.name}
                </MenuItem>
              ))}
            </SelectPlaceholder>
          </Grid>
        )}

        {page !== 'home' && page !== 'application' && authStoreFunc.isAdmin() && (
          <Grid item xs={12} md={4} lg={2}>
            <AutoCompleteField
              fullWidth
              value={homeStore.filter.assignTo}
              onChange={homeStoreFunc.handleFilterChange}
              options={homeStore.managers}
              keyArr={'username'}
              labelKeys={['firstName', 'lastName']}
              valueKey={'username'}
              name="assignTo"
              placeholder="Менеджер"
            />
          </Grid>
        )}

        <Grid item xs={12} md={4} lg={2}>
          <TextField
            name="clientFullName"
            value={homeStore.filter?.clientFullName || ''}
            onChange={homeStoreFunc.handleFilterChange}
            fullWidth
            placeholder="ФИО клиента"
          />
        </Grid>

        {page === 'completed' && (
          <>
            <Grid item xs={12} md={4} lg={2}>
              <DatePicker
                maxDate={new Date()}
                placeholder="От"
                format="dd.MM.yyyy"
                name="completedByFrom"
                value={homeStore.filter?.completedByFrom}
                fullWidth
                onChange={e => homeStoreFunc.handleFilterDateChange(e, 'completedByFrom')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position={'start'}>
                      <DateIcon style={{ color: GRAY_COLORS[500] }} />
                    </InputAdornment>
                  )
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <DatePicker
                maxDate={new Date()}
                placeholder="До"
                format="dd.MM.yyyy"
                name="completedByTo"
                value={homeStore.filter?.completedByTo}
                fullWidth
                onChange={e => homeStoreFunc.handleFilterDateChange(e, 'completedByTo')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position={'start'}>
                      <DateIcon style={{ color: GRAY_COLORS[500] }} />
                    </InputAdornment>
                  )
                }}
                KeyboardButtonProps={{
                  'aria-label': 'change date'
                }}
              />
            </Grid>
          </>
        )}

        {page === 'application' && (
          <>
            <Grid item xs={12} md={4} lg={2}>
              <SelectPlaceholder
                IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px' }} />}
                value={homeStore.filter?.applicationType ?? ''}
                name="applicationType"
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                placeholder="Тип заявки"
              >
                <MenuItem value="">Не выбрано</MenuItem>
                <MenuItem value="SUSPENSION">SUSPENSION</MenuItem>
                <MenuItem value="BUYBACK">BUYBACK</MenuItem>
                <MenuItem value="WRITE_OFF">WRITE_OFF</MenuItem>
              </SelectPlaceholder>
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <SelectPlaceholder
                IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px' }} />}
                value={homeStore.filter?.applicationStatus ?? ''}
                name="applicationStatus"
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                placeholder="Статус заявки"
              >
                <MenuItem value="">Не выбрано</MenuItem>
                <MenuItem value="SUBMITTED">На согласовании</MenuItem>
                <MenuItem value="COMPLETED">Согласовано</MenuItem>
                <MenuItem value="REJECTED">Отклонено</MenuItem>
              </SelectPlaceholder>
            </Grid>

            <Grid item xs={12} md={4} lg={2}>
              <SelectPlaceholder
                IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px' }} />}
                value={homeStore.filter?.workListStatusCode ?? ''}
                name="workListStatusCode"
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                placeholder="Статус рабоч.листа"
              >
                <MenuItem value="">Не выбрано</MenuItem>
                {[
                  'NEW',
                  'IN_PROGRESS',
                  'IN_PROGRESS_LAWYER',
                  'OFFBALANCE',
                  'CLOSED_WITHOUT_MANAGER',
                  'RESTRUCTURED',
                  'FULL_COMPLETED',
                  'COMPLETED'
                ].map(code => (
                  <MenuItem key={code} value={code}>
                    {getStatusLabel(code)}
                  </MenuItem>
                ))}
              </SelectPlaceholder>
            </Grid>

            <Grid item xs={12} md={4} lg={2}>
              <TextField
                name="loanAmountFrom"
                type="number"
                inputProps={{ min: 0 }}
                value={homeStore.filter?.loanAmountFrom || ''}
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                placeholder="Сумма кредита от"
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <TextField
                name="loanAmountTo"
                type="number"
                inputProps={{ min: 0 }}
                value={homeStore.filter?.loanAmountTo || ''}
                onChange={homeStoreFunc.handleFilterChange}
                fullWidth
                placeholder="Сумма кредита до"
              />
            </Grid>

            <Grid item xs={12} md={4} lg={2}>
              <DatePicker
                maxDate={new Date()}
                placeholder="Заявка с"
                format="dd.MM.yyyy"
                name="applicationDateFrom"
                value={homeStore.filter?.applicationDateFrom || null}
                fullWidth
                onChange={e => homeStoreFunc.handleFilterDateChange(e, 'applicationDateFrom')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <DateIcon style={{ color: GRAY_COLORS[500] }} />
                    </InputAdornment>
                  )
                }}
                KeyboardButtonProps={{ 'aria-label': 'change date' }}
              />
            </Grid>
            <Grid item xs={12} md={4} lg={2}>
              <DatePicker
                maxDate={new Date()}
                placeholder="Заявка по"
                format="dd.MM.yyyy"
                name="applicationDateTo"
                value={homeStore.filter?.applicationDateTo || null}
                fullWidth
                onChange={e => homeStoreFunc.handleFilterDateChange(e, 'applicationDateTo')}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <DateIcon style={{ color: GRAY_COLORS[500] }} />
                    </InputAdornment>
                  )
                }}
                KeyboardButtonProps={{ 'aria-label': 'change date' }}
              />
            </Grid>
          </>
        )}

        {page !== 'application' && (
          <>
            <Grid item xs={12} md={3}>
              <AutoCompleteField
                fullWidth
                name={'subdivisionNames'}
                value={homeStore.filter?.subdivisionNames}
                onChange={homeStoreFunc.handleFilterChange}
                options={branchesWithCode}
                valueKey={'code'}
                keyArr={'code'}
                labelKey={'code'}
                placeholder={'Филиал'}
                multiple
              />
            </Grid>
          </>
        )}

        {page !== 'application' && (
          <Grid item xs={12} md={4} lg={2}>
            <SelectPlaceholder
              IconComponent={props => <ExpandMoreIcon {...props} style={{ margin: '0 8px 0 8px' }} />}
              value={homeStore.filter?.level || null}
              name={'level'}
              onChange={homeStoreFunc.handleFilterChange}
              fullWidth
              placeholder={'LEVEL'}
            >
              <MenuItem value={''}>Не выбрано</MenuItem>
              <MenuItem value={1}>1</MenuItem>
              <MenuItem value={2}>2</MenuItem>
              <MenuItem value={3}>3</MenuItem>
              <MenuItem value={4}>4</MenuItem>
              <MenuItem value={5}>5</MenuItem>
              <MenuItem value={6}>6</MenuItem>
            </SelectPlaceholder>
          </Grid>
        )}
        <Grid item xs={12} md={4} lg={2}>
        <AutoCompleteField
          fullWidth
          name={'creditProducts'}
          value={homeStore.filter?.creditProducts}
          onChange={homeStoreFunc.handleFilterChange}
          options={homeStore?.creditProducts}
          valueKey={'code'}
          keyArr={'code'}
          labelKey={'code'}
          placeholder={'Продукт'}
          multiple
        />
      </Grid>
      </Grid>



      <Grid item container justifyContent={'flex-end'} spacing={2}>
        <Grid item xs={12} md={2}>
          <Button fullWidth variant={'outlined'} onClick={onClear}>
            Сбросить фильтр
          </Button>
        </Grid>

        <Grid item xs={12} md={2}>
          <Button fullWidth variant={'contained'} style={{ minWidth: 160 }} color={'primary'} onClick={onSearch}>
            Найти
          </Button>
        </Grid>
      </Grid>
    </>
  )
}
